export default {
  information: '资讯',
  latestExhibition: '最新展会',
  latestNews: '最新资讯',
  notMultiple: '不支持多选',
  source: '来源',
  category: '分类',
  unfollowAction: '取消关注',
  followAction: '关注',
  unlikeAction: '取消点赞',
  likeAction: '点赞',
  shareAction: '分享',
  relatedTags: '相关标签',
  copyrightStatement:
    '声明：文章部分图文版权归原创作者所有，不做商业用途，如有侵权，请与我们联系删除',
  industryExhibitions: '行业展会',
  relatedNews: '相关资讯',
  industryNews: '行业资讯',
  wechatScanPrompt: '请使用手机微信扫码关注'
}
